
export default {
  props: {
    shoppingListCode: {
      type: String,
      default: null,
    },

    product: {
      type: Object,
      required: true,
    },

    smallArrow: {
      type: Boolean,
      default: false,
    },

    hovered: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isHover: false,
    }
  },

  computed: {
    canOnlyBeBoughtExternally() {
      return ['E-Book', 'App'].includes(this.product.product_type)
    },
  },
}
